import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.less';
const SHEET_TRANSITION = {
    duration: 0.24,
    ease: [
        0.22,
        1,
        0.36,
        1
    ]
};
function MobileBottomSheet(props) {
    const { children, visible, ariaLabel, className, onClose } = props;
    const [container, setContainer] = useState(null);
    useEffect(()=>{
        setContainer(document.body);
    }, []);
    if (!container) {
        return null;
    }
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(AnimatePresence, {
        children: visible && /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx(motion.button, {
                    type: "button",
                    "aria-label": intl.get('workspace.sidebar.close'),
                    className: styles.mask,
                    onClick: onClose,
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.18
                    }
                }),
                /*#__PURE__*/ _jsx(motion.div, {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": ariaLabel,
                    className: [
                        styles.sheet,
                        className
                    ].filter(Boolean).join(' '),
                    initial: {
                        y: '100%'
                    },
                    animate: {
                        y: 0
                    },
                    exit: {
                        y: '100%'
                    },
                    transition: SHEET_TRANSITION,
                    children: children
                })
            ]
        })
    }), container);
}
export default MobileBottomSheet;
